import { Button, ButtonProps } from "antd";

const ButtonSimple = (props: ButtonProps) => {

  const {
    children,
    className,
    ...rest
  } = props;

  return (
    <Button
      {...rest}
      className={` ${className}`}
    >
      {children}
    </Button>
  );
};

export default ButtonSimple;

// !bg-[#4a5568] !hover:bg-[#2d3748] font-semibold !hover:text-white !text-white !focus:text-white